import React from 'react';
import './Hero.css';
import prescriptionIcon from '../prescription.png';

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              AI-Powered Diabetes Treatment Assistant 
            </h1>
            <p className="hero-description">
              GlucoPlanner revolutionizes diabetes care by providing doctors with intelligent, 
              personalized treatment recommendations based on <b>International Standards</b>. Generate comprehensive 
              prescriptions including medication, lifestyle, and diet plans with just a few clicks.
            </p>
            <div className="hero-buttons">
              <button onClick={scrollToContact} className="btn btn-primary">
                Get Updates
              </button>
              <button onClick={() => document.getElementById('features').scrollIntoView({ behavior: 'smooth' })} className="btn btn-secondary">
                Learn More
              </button>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-card">
              <div className="card-header">
                <div className="card-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
              <div className="card-content">
              <img src={prescriptionIcon} alt="Prescription Icon" className="icon-size" />,
                <h3>AI-Powered Prescriptions</h3>
                <p>Generate personalized diabetes treatment plans in seconds</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
